var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "220px" },
                    attrs: {
                      placeholder: "选择种草官",
                      clearable: "",
                      filterable: "",
                    },
                    model: {
                      value: _vm.searchForm.officerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "officerId", $$v)
                      },
                      expression: "searchForm.officerId",
                    },
                  },
                  _vm._l(_vm.officers, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "month",
                    "value-format": "yyyy-MM",
                    placeholder: "选择月",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.searchForm.month,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "month", $$v)
                    },
                    expression: "searchForm.month",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "状态", clearable: "" },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "完成", value: "1" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "未完成", value: "0" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              border: "",
              "element-loading-text": "数据加载中...",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "种草官", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "month", label: "月份", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "当前任务及完成数",
                prop: "remark",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "完成状态", prop: "status", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.status == 1
                        ? _c("div", [_vm._v("完成")])
                        : _c("div", [_vm._v("未完成")]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "250",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openRewardDialog(scope.row)
                                },
                              },
                            },
                            [_vm._v("奖励记录")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "奖励记录",
              visible: _vm.rewardDialogVisible,
              width: "60%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.rewardDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.rewardLoading,
                        expression: "rewardLoading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.rewardList, stripe: "", border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "id",
                        label: "ID",
                        width: "80",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "奖励类型", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.rewardType == 1
                                ? _c("div", [_vm._v("积分")])
                                : scope.row.rewardType == 2
                                ? _c("div", [_vm._v("优惠券")])
                                : _c("div", [_vm._v("其他")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "couponId",
                        label: "奖励内容",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.rewardType == 2
                                ? _c("div", [
                                    _vm._v(
                                      "优惠券ID:" + _vm._s(scope.row.couponId)
                                    ),
                                  ])
                                : _c("div", [
                                    _vm._v(_vm._s(scope.row.rewardValue)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "status", label: "状态", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status == 0
                                ? _c("div", [_vm._v("待发放")])
                                : scope.row.status == 1
                                ? _c("div", [_vm._v("发放中")])
                                : scope.row.status == 2
                                ? _c("div", [_vm._v("发放成功")])
                                : scope.row.status == 3
                                ? _c("div", [_vm._v("发放失败")])
                                : _c("div", [_vm._v(_vm._s(scope.row.status))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: "时间",
                        align: "center",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "12px",
                      "text-align": "right",
                    },
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "total, prev, pager, next, jumper",
                        "current-page": _vm.rewardSearch.page,
                        "page-size": _vm.rewardSearch.limit,
                        total: _vm.rewardSearch.total,
                      },
                      on: {
                        "current-change": _vm.handleRewardPageChange,
                        "size-change": _vm.handleRewardSizeChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }